import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { ChannelBinding } from "@/types";

// #182: Bindings pro User. Master-API: GET /channel-bindings?userId=...
export function useUserBindings(userId: string | undefined): UseQueryResult<ChannelBinding[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: userId
      ? [...queryKeys.detail("users", userId), "bindings"]
      : ["resources", "users", "_invalid", "bindings"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<ChannelBinding[]>(`/channel-bindings?userId=${encodeURIComponent(userId!)}`);
    },
    enabled: !!userId && !!session,
  });
}
